import { BotRegion } from '../../../../../../common/enums/bot/bot-region.enum'

export const botRegionFilter = (botRegion: BotRegion) => {
  if (!botRegion || botRegion === BotRegion.EU_WEST) return 'EU'
  if (botRegion === BotRegion.US_EAST) return 'US'
}
